import {
	IContestPlayerStatsStore,
	IContestStat,
} from "data/stores/contest_player_stats/contest_player_stats.store";
import {ISquadsStore} from "data/stores/squads/squads.store";
import {IPlayersStore} from "data/stores/players/players.store";
import {IContestsStore} from "data/stores/contests/contestsStore";
import {ITournamentsStore} from "data/stores/tournaments/tournaments.store";

interface IStatPoints {
	hitting: Record<Exclude<keyof IContestStat["hitting"], "atBats" | "hits">, number>;
	pitching: Record<Exclude<keyof IContestStat["pitching"], "inningsPitched">, number>;
}

interface IGamePlayerOptions {
	playersStore: IPlayersStore;
	contestStatsStore: IContestPlayerStatsStore;
	squadsStore: ISquadsStore;
}

interface IOpponentSquadOptions {
	playersStore: IPlayersStore;
	contestStore: IContestsStore;
	squadsStore: ISquadsStore;
	tournamentsStore: ITournamentsStore;
}

export abstract class PlayerUtils {
	public static buildGamePlayer(
		playerId: number,
		{playersStore, contestStatsStore, squadsStore}: IGamePlayerOptions
	) {
		const player = playersStore.listById[playerId];
		return (
			player && {
				...player,
				squad: squadsStore.getSquadById(player.squadId),
				contestStats: contestStatsStore.getPlayerStats(playerId),
			}
		);
	}

	public static buildOpponentSquad(
		playerId: number,
		{playersStore, contestStore, squadsStore, tournamentsStore}: IOpponentSquadOptions
	) {
		const player = playersStore.getPlayerById(playerId);
		const contestId = contestStore.currentContest?.id;

		if (!player || !contestId) {
			return "";
		}

		const match = tournamentsStore.list.find(
			(it) =>
				it.contestId === contestId &&
				[it.homeSquadId, it.awaySquadId].includes(player.squadId)
		);

		if (!match) {
			return "";
		}

		const isHome = match.homeSquadId === player.squadId;
		const opponentSquad = squadsStore.getSquadById(
			isHome ? match.awaySquadId : match.homeSquadId
		);

		if (!opponentSquad) {
			return "";
		}

		return `${isHome ? "vs" : "@"} ${opponentSquad.abbreviation}`;
	}

	public static statsPoints: IStatPoints = {
		hitting: {
			single: 2,
			double: 4,
			triple: 6,
			homeRun: 8,
			steal: 4,
			walk: 2,
			rbi: 4,
			run: 4,
			hbp: 1,
			cycle: 10,
			grandSlam: 5,
			strikeout: -1,
			caughtStealing: -2,
			gidp: -3,
		},
		pitching: {
			out: 1,
			strikeout: 1,
			scorelessInning: 1,
			successfulPickOff: 3,
			win: 5,
			qualityStart: 8,
			completeGame: 10,
			shutout: 15,
			noHitter: 25,
			perfectGame: 50,
			hitsAllowed: -1,
			earnedRuns: -2,
			walks: -2,
			batterHit: -1,
			losses: -5,
			wildPitch: -1,
		},
	};
}
